import { gql } from '@apollo/client'

export const GET_ALL_LOGS_EMPLOYEES = gql`
  query GetAllEmployeeLogs(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filters: filterEmployeeLogsInput
  ) {
    getAllEmployeeLogs(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      count
      rows {
        id
        employee_id
        check_type
        photo_url
        latitude
        longitude
        check_date
        log_status
        lateness_time
        left_early_time
        is_active
        created_at
        updated_at
        formatted_log_status
        formatted_check_type
        EmployeeLogsToEmployee {
          first_name
          phone
          last_name
          email
        }
        EmployeeLogsToJustification {
          id
          document_url
          justification_date
          justification_type_spanish
          status
          justification_type
        }
      }
    }
  }
`

export const GET_ONE_LOG_EMPLOYEE_BY_ID = gql`
  query GetEmployeeLogById($getEmployeeLogByIdId: Int!) {
    getEmployeeLogById(id: $getEmployeeLogByIdId) {
      id
      employee_id
      check_type
      photo_url
      latitude
      longitude
      check_date
      log_status
      lateness_time
      left_early_time
      is_active
      created_at
      updated_at
      EmployeeLogsToEmployee {
        first_name
        phone
        last_name
        email
      }
      EmployeeLogsToJustification {
        id
        document_url
        justification_date
        justification_type_spanish
        status
        justification_type
      }
    }
  }
`

export const REGISTER_LOG_EMPLOYEE = gql`
  mutation ActiviteEmployeeLog($activiteEmployeeLogId: Int!) {
    ActiviteEmployeeLog(id: $activiteEmployeeLogId) {
      mode
      status
      message
    }
  }
`

export const EXPORT_ALL_LOGS_EMPLOYEES = gql`
  mutation ExportEmployeeLogs(
    $searchQuery: String
    $limit: Int
    $offset: Int
    $filters: filterEmployeeLogsInput
  ) {
    exportEmployeeLogs(
      searchQuery: $searchQuery
      limit: $limit
      offset: $offset
      filters: $filters
    ) {
      employee
      punch_in
      punch_out
      lateness
      early_leave
      absences
      justfications
    }
  }
`

export const EXPORT_ALL_LOGS_EMPLOYEES_BY_EMPLOYEE_ID = gql`
  mutation ExportEmployeeByEmployeeId(
    $employeeId: Int!
    $filters: filterEmployeeLogsInput
  ) {
    exportEmployeeByEmployeeId(employee_id: $employeeId, filters: $filters) {
      date
      hour_in
      hour_out
      lateness
      early_leave
      absences
      status_log
      status
      justification_type
    }
  }
`
export const GET_CHECK_TYPES = gql`
  query GetCheckTypes {
    getCheckTypes {
      value
      label
    }
  }
`

export const GET_LOG_STATUSES = gql`
  query GetLogStatuses {
    getLogStatuses {
      value
      label
    }
  }
`
